<div class="row">
  <i class="fa fa-male"></i>
  <div class="col-md-6 col-md-offset-3">
    @if (msg) {
      <div>
        <div class="alert alert-warning">{{ msg }}</div>
      </div>
    }
    <form class="form-register form-group">
      <span class="glyphicon glyphicon-user" aria-hidden="true"></span>
      <i>Personal information</i>
      <hr />
      <div class="form-group row">
        <div class="col-md-4">
          <label for="firstname">First name</label>
          <input autocomplete="given-name" (ngModelChange)="update_user_id($event, 0)" id="firstname" [ngModelOptions]="{ standalone: true }" [(ngModel)]="first_name" type="text" class="form-control" required />
        </div>
        <div class="col-md-4">
          <label for="lastname">Last name</label>
          <input autocomplete="family-name" (ngModelChange)="update_user_id($event, 1)" id="lastname" [ngModelOptions]="{ standalone: true }" [(ngModel)]="last_name" type="text" class="form-control" required />
        </div>
        <div class="col-md-4">
          <label for="email">Username</label>
          <input autocomplete="username" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user_id" type="text" id="userid" class="form-control" required />
        </div>
      </div>
      <div class="form-group">
        <label for="email">Professional email</label>
        <input autocomplete="email" [ngModelOptions]="{ standalone: true }" [(ngModel)]="email" type="email" id="email" class="form-control" required autofocus />
        <small id="emailHelp" class="form-text text-muted">Please provide a professional email address (please avoid gmail, yahoo, etc.).</small>
      </div>
      @if (session_user && session_user.is_admin) {
        <div class="form-group">
          <div class="checkbox">
            <label><input type="checkbox" [ngModelOptions]="{ standalone: true }" [(ngModel)]="send_copy_to_support" /> Send a Copy of all mail to Support Team (include mail with password)</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" [ngModelOptions]="{ standalone: true }" [(ngModel)]="create_imap_mailbox" /> Create Imap Mailbox (if enable in cluster template)</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" [ngModelOptions]="{ standalone: true }" [(ngModel)]="is_fake" /> Flag as Fake Account (Applicative account)</label>
          </div>
        </div>
      }
      <br />
      <span class="glyphicon glyphicon-home" aria-hidden="true"></span>
      <i>Laboratory information</i>
      <hr />
      <div class="form-group row">
        <div class="col-md-6">
          <label for="lab">Laboratory</label>
          <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="lab" type="text" id="lab" class="form-control" required />
          <small id="labHelp" class="form-text text-muted">Research unit or laboratory.</small>
        </div>
        <div class="col-md-6">
          <label for="responsible">Manager</label>
          <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="responsible" id="responsible" type="text" class="form-control" required />
          <small id="responsibleHelp" class="form-text text-muted">Director or supervisor name.</small>
        </div>
      </div>
      <div class="form-group">
        <label for="address">Address</label>
        <textarea [ngModelOptions]="{ standalone: true }" [(ngModel)]="address" id="address" class="form-control" required autofocus></textarea>
      </div>
      <div class="form-group">
        <label for="Team">Team</label>
        <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="team" type="text" id="team" class="form-control" placeholder="Lowercase and/or digits" required />
        <small id="groupHelp" class="form-text text-muted">
          Use the <i>institution_researchunit</i> format (ex: <b>inra_umr1246, cnrs_umr3503</b>).<br />
          Lowercase letters (a-z), digits (0-9) and underscores ( _ ) only.
        </small>
      </div>
      <br />
      <span class="glyphicon glyphicon-comment" aria-hidden="true"></span>
      <i>Other information</i>
      <hr />
      <div class="form-group">
        <label for="why">Why do you need an account</label>
        <textarea [ngModelOptions]="{ standalone: true }" [(ngModel)]="why" id="why" class="form-control" required></textarea>
        <small id="responsibleHelp" class="form-text text-muted"> Please specify the scientific purpose of the usage and if you want to join a specific scientific group or project already present on our systems. You can also specify which kind of resources you would like to use and the estimated amount of storage needed. </small>
      </div>
      <div class="form-group">
        <label for="duration">Duration</label>
        <select id="duration" [ngModelOptions]="{ standalone: true }" [(ngModel)]="duration" class="form-control" required>
          @for (duration of config.duration; track duration) {
            <option>{{ duration }}</option>
          }
        </select>
      </div>
      <app-user-extra (extraValues)="onExtraValue($event)"></app-user-extra>
      @if (config.enable_ui && config.enable_ui.ip) {
        <input type="hidden" [ngModelOptions]="{ standalone: true }" [(ngModel)]="ip" type="text" id="ip" class="form-control" placeholder="IP Address" required />
      }
      <br />
      <span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>
      <i>Terms of use</i>
      <hr />
      <div class="checkbox">
        <label><input type="checkbox" [ngModelOptions]="{ standalone: true }" [(ngModel)]="agree" required /> I agree with the <a target="_blank" aria-label="terms of user" href="{{ config.terms_of_use }}">terms of use</a> of the {{ config.name }} platform</label>
      </div>
      @if (!session_user) {
        <div>
          <p-button type="button" styleClass="-lg btn-primary btn-block" [ngStyle]="{ display: 'block' }" (onClick)="register()" label="Register"></p-button>
        </div>
      }
      @if (session_user && session_user.is_admin) {
        <div>
          <p-button type="button" styleClass="-lg btn-primary btn-block" [ngStyle]="{ display: 'block' }" (onClick)="register()" label="Create New Account"></p-button>
        </div>
      }
      @if (msg) {
        <div>
          <div class="alert alert-warning">{{ msg }}</div>
        </div>
      }
    </form>
  </div>
</div>
